import React from 'react';
import ToastProvider from './ToastProvider';
import { WizardProvider } from '../wizard';
import { WizardShell } from '../wizard/WizardShell';
import { useWizardRuntime } from '../wizard/useWizardRuntime';

const WizardInternal: React.FC = () => {
  const {
    isLoading,
    currentStepId,
    progress,
    stepName,
    contextValue
  } = useWizardRuntime();

  return (
    <WizardProvider value={contextValue}>
      <WizardShell
        isLoading={isLoading}
        currentStepId={currentStepId}
        progress={progress}
        stepName={stepName}
      />
    </WizardProvider>
  );
};

const WizardHost: React.FC = () => {
  return (
    <ToastProvider>
      <WizardInternal />
    </ToastProvider>
  );
};

export default WizardHost;
